// 「元に戻す」の対象 1 件。自分の線 (stroke.end 済み) と自分の範囲の移動・コピー
// (`whiteboard.region` の echo 済み) を、同じ一覧 (新しい順) に混ぜて扱う。
// engine (`getCancellableOps`) と hook (`useConflictAwareUndo`) が共有する型。

export type CancellableOp =
  | { readonly kind: 'stroke'; readonly sid: string }
  | { readonly kind: 'region'; readonly regionSeq: number };

/** 同じ対象か (一覧の重複排除・削除に使う)。 */
export const isSameOp = (a: CancellableOp, b: CancellableOp): boolean =>
  a.kind === 'stroke'
    ? b.kind === 'stroke' && a.sid === b.sid
    : b.kind === 'region' && a.regionSeq === b.regionSeq;
